import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import pic01 from '../images/pic01.jpg'
import pic03 from '../images/pic03.jpg'
import pic02 from '../images/nextstepdegrees.png'
import pic04 from '../images/idearoom.png'
import pic05 from '../images/surfair.png'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSubmitted: false,
    }
  }

  resetComponent = (nextProps = {}) => {
    setTimeout(() => {
      this.setState({
        isSubmitted: !nextProps.isArticleVisible,
      })
    }, 500)
  }

  componentWillReceiveProps(nextProps) {
    this.resetComponent(nextProps)
  }

  handleSubmit(event) {
    event.preventDefault()
    const data = new FormData(event.target)
    const options = {
      hideProgressBar: true,
      closeButton: false,
      position: toast.POSITION.TOP_CENTER,
      className: ({
        background: '#00b57d',
      }),
    }
    fetch(
      'https://script.google.com/macros/s/AKfycbwsyr2v3KuyXnms7Zi2fpixYB2Tpa_LjfXXuv9-/exec',
      {
        method: 'POST',
        body: data,
      },
    ).then(response => {
      if (response.status === 200) {
        toast.success('Sent. I will get back to you shortly', options)
        setTimeout(() => {
          this.props.onCloseArticle()
        }, 2000)
      } else {
        toast.error('Something went wrong. Try again later', options)
      }
    })
  }

  // confirmation() {
  //   const { isSubmitted } = this.state
  //   if (isSubmitted) {
  //     return (
  //       <div>
  //         <h2 className="major">Sent</h2>
  //         <h3>I'll get back to you soon.</h3>
  //         <br/>
  //       </div>
  //     )
  //   }
  //   else {
  //     return
  //   }
  // };

  render() {
    let close = (
      <div
        className="close"
        onClick={() => {
          this.props.onCloseArticle()
        }}
      />
    )

    const { isSubmitted } = this.state

    return (
      <div
        id="main"
        style={this.props.timeout ? { display: 'flex' } : { display: 'none' }} onClick={(e) => e.stopPropagation()}
      >
        <ToastContainer/>
        <article
          id="intro"
          className={`${this.props.article === 'intro' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
            }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Intro</h2>
          <span className="image main">
            <img src={pic01} alt=""/>
          </span>
          <p>
            Aenean ornare velit lacus, ac varius enim ullamcorper eu. Proin
            aliquam facilisis ante interdum congue. Integer mollis, nisl amet
            convallis, porttitor magna ullamcorper, amet egestas mauris. Ut
            magna finibus nisi nec lacinia. Nam maximus erat id euismod egestas.
            By the way, check out my <a href="#work">awesome work</a>.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
            dapibus rutrum facilisis. Class aptent taciti sociosqu ad litora
            torquent per conubia nostra, per inceptos himenaeos. Etiam tristique
            libero eu nibh porttitor fermentum. Nullam venenatis erat id
            vehicula viverra. Nunc ultrices eros ut ultricies condimentum.
            Mauris risus lacus, blandit sit amet venenatis non, bibendum vitae
            dolor. Nunc lorem mauris, fringilla in aliquam at, euismod in
            lectus. Pellentesque habitant morbi tristique senectus et netus et
            malesuada fames ac turpis egestas. In non lorem sit amet elit
            placerat maximus. Pellentesque aliquam maximus risus, vel sed
            vehicula.
          </p>
          {close}
        </article>

        <article
          id="work"
          className={`${this.props.article === 'work' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
            }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Surf Airlines</h2>
          <span className="image main">
            <img src={pic05} alt=""/>
          </span>
          <p>
            As the sole in-house Front End Engineer for almost 4 years, my
            responsibilities include working with designers, business
            stakeholders, and other engineers to create simplified,
            functional, and responsive user experiences for customer facing and internal front
            end systems of Surf Air technologies using ReactJS and AngularJS.
            Primarily focused on the front end development and maintenance of various web applications connected
            to RESTful API backends on NodeJS, Python, and Perl. Each application has numerous integrations with various
            third party services as tools for analytics, lead generation, and more. Systems all
            deployed using automated build processes and workflow version
            control with Git. Implemented tasks such as ESLint to maintain code consistency and quality with ease.
          </p>

          <a
            href="https://us.surfair.com"
            target="_blank" rel="noreferrer"
            className="work-button"
          >
            <button>View website</button>
          </a>

          <h2 className="major">Idea Room</h2>
          <span className="image main">
            <img src={pic04} alt=""/>
          </span>
          <p>
            Every successful business starts with an idea. Idea Room is a website development and digital marketing team
            that helps companies launch new products & services or re-position and re-purpose existing offerings.
            Specializing in digital marketing, the&nbsp;<a href="https://idearoom.la" target="_blank">
            Idearoom.la</a>&nbsp;website uses video and scrolling animations to help tell the user a
            story about how the company can help clients take their businesses
            to the next level.
          </p>

          <a href="https://idearoom.la" target="_blank" className="work-button">
            <button>View website</button>
          </a>

          <h2 className="major">Next Step Degrees</h2>
          <span className="image main">
            <img src={pic02} alt=""/>
          </span>
          <p>
            Next Step Degrees is designed to offer specialized career training & education for college graduates and
            individuals interested in pursuing new careers in a variety of professions. This clean and minimal design
            was built with ReactJS along with GatsbyJS and uses third party integration for a client needing to get to
            market quickly.
          </p>

          <a
            href="https://nextstepdegrees.com"
            target="_blank"
            className="work-button"
          >
            <button>View website</button>
          </a>

          {close}
        </article>

        <article
          id="about"
          className={`${this.props.article === 'about' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
            }`}
          style={{
            display: 'none',
          }}
        >
          <h2 className="major"> About </h2>
          <span className="image main">
            <img src={pic03} alt=""/>
          </span>
          <p>
            {' '}
            Lorem ipsum dolor sit amet, consectetur et adipiscing elit.Praesent
            eleifend dignissim arcu, at eleifend sapien imperdiet ac.Aliquam
            erat volutpat.Praesent urna nisi, fringila lorem et vehicula lacinia
            quam.Integer sollicitudin mauris nec lorem luctus ultrices.Aliquam
            libero et malesuada fames ac ante ipsum primis in faucibus.Cras
            viverra ligula sit amet ex mollis mattis lorem ipsum dolor sit amet.
          </p>
          {close}
        </article>

        <article
          id="message"
          className={`${this.props.article === 'contact' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
            }`}
          style={{ display: 'none' }}
        >
          <div>
            <h2 className="major">Reach out</h2>
            <form onSubmit={e => this.handleSubmit(e)}>
              <div className="field half first">
                <label htmlFor="name">Name</label>
                <input type="text" name="name" id="name"/>
              </div>
              <div className="field half">
                <label htmlFor="email">Email</label>
                <input type="text" name="email" id="email"/>
              </div>
              <div className="field">
                <label htmlFor="message">Message</label>
                <textarea name="message" id="message" rows="4"/>
              </div>
              <ul className="actions">
                <li>
                  <input
                    type="submit"
                    value="Send Message"
                    className="special"
                  />
                </li>
                <li>
                  <input type="reset" value="Reset"/>
                </li>
              </ul>
            </form>
          </div>
          <ul className="icons">
            <li>
              <a
                target="_blank"
                href="mailto:jeremyzander@gmail.com"
                className="icon fa-envelope"
              >
                {' '}
                <span className="label"> Email </span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://github.com/jzander"
                className="icon fa-github"
              >
                <span className="label">GitHub</span>
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="tel:15167764428"
                className="icon fa-phone"
              >
                {' '}
                <span className="label"> Phone </span>
              </a>
            </li>
          </ul>
          {close}
        </article>
      </div>
    )
  }
}

Main.propTypes = {
  route: React.PropTypes.object,
  article: React.PropTypes.string,
  articleTimeout: React.PropTypes.bool,
  onCloseArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool,
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js